<ngx-smart-modal
    #EditSharedBclSettingsModalComponent
    class="edit-shared-bcl-convert-settings-modal"
    [identifier]="modalType"
    [closable]="true"
    [title]="modalTitle"
    [showCloseButton]="true"
    [showConfirmButton]="true"
    [closeButtonText]="closeButtonText"
    [confirmButtonText]="confirmButtonText">
    <div class="rad-typography-font-weight--semiBold">
        {{ configTitle }}
    </div>
    <div *ngIf="formGroup" class="mt-4">
        <form [formGroup]="formGroup">
            <app-dynamic-settings-form
                [formFields]="bclConvertSettingsFields"
                [showHyperlinkInDescription]="showHyperLink"
                formControlName="bclConvertSettingsValues">
            </app-dynamic-settings-form>
        </form>
    </div>
</ngx-smart-modal>